export class PaymentSettings {
  public static SCRIPT_URL = 'https://js.begateway.com/begateway-1.2.6.min.js';
  public static BASE_API_URL = 'https://checkout.bepaid.by/v2';
  public static BEPAID_URL = 'https://bepaid.by';
}
